<template>
    <div class="center-goods">
        <!-- 标题 -->
        <center-title>
            {{$t("message.cgoods.title")}}（{{total}}）
        </center-title>
        <!-- 筛选条件 -->
        <div class="goods-filter">
            <plist-filter-list
                :list-title="$t('message.plist.category')"
                :list-data="subcate"
                @handleClick="arg => handleFun(search, arg, brand_id, sort)">
            </plist-filter-list>
            <plist-filter-list
                :list-title="$t('message.plist.brand')"
                :list-data="brand"
                @handleClick="arg => handleFun(search, id, arg, sort,1)">
            </plist-filter-list>
        </div>
        <!-- 商品部分 -->
        <div class="goods-content">
            <!-- 排序规则 -->
            <goods-sort
				 :serial="successively"
                 :goods-sort="sort"
				 @handelSearch="arg => handleFun(arg, id, brand_id, sort,1)"
                 @handleSort="arg => handleFun(search, id, brand_id, arg,1)">
            </goods-sort>
            <!-- 商品内容 -->
            <el-row 
                :gutter="20"
                v-if="user_goods&&user_goods.length>0">
                <el-col :span="6" v-for="(item,index) in user_goods" :key="index">
                    <div :class="[
                            'center-goods-box',
                            {'hover-box': enter_index === index}
                        ]"
                        @mouseenter="handleMove(index)"
                        @mouseleave="handleMove(-1)">
                        <!-- 商品项 -->
                        <center-goods-list
                            :goods="item">
                        </center-goods-list>
                        <!-- 收藏按钮 -->
                        <div v-if="power.includes(17) || power.includes(0) || power.includes(111)" :class="[
                                'center-goods-collection',
                                {'is-collection':item.collection>0}
                            ]">
                            <a href="javascript:;"
                                @click="handleCollection(item)">
                                <i class="glyphicon glyphicon-heart-empty"></i>
                            </a>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!-- 暂无商品 -->
            <div class="content-nothing"
                v-else>
                {{$t("message.cgoods.nothing")}}
            </div>
            <!-- 分页器 -->
            <div class="content-pagination">
             <!--   <el-pagination
					@size-change="handleSizeChange"
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-count="pageCount"
                    @current-change="arg => handleFun(search, id, brand_id, sort, arg)"
                    background>
                </el-pagination> -->
				<el-pagination
				  @size-change="handleSizeChange"
				  @current-change="arg => handleFun(search, id, brand_id, sort, arg,currentPage2)"
				  :current-page.sync="currentPage2"
				  :page-size="per_page"
				  layout="prev, pager, next, jumper"
				  :total="total"
				  background>
				</el-pagination>
            </div>
        </div>
        <!-- 属性选择模态框 -->
        <get-attr></get-attr>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    data() {
        return {
			pager:0,
			currentPage2:1,
            search: '',
            id: '',
            brand_id: '',
            sort: '',
            enter_index: -1
        }
    },
    computed: mapState({
        subcate: state => state.goods.subcate,
        brand: state => state.goods.brand,
        islogin: state => state.user.islogin,
        power: state => state.user.power,
        character_id: state => state.user.character_id,
        user_goods: state => state.goods.user_goods,
        total: state => state.goods.total,
		per_page: state => state.goods.per_page,
        currentPage: state => state.goods.currentPage,
		successively: state => state.goods.successively,
        pageCount: state => state.goods.pageCount,
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        plistFilterList: () => import('@/components/plistFilterList'),
        goodsSort: () => import("@/components/center/goodsSort"),
        centerGoodsList: () => import("@/components/center/centerGoodsList"),
        getAttr: () => import("@/components/getAttr"),
    },
    watch: {
		currentPage(){
			this.currentPage2 = this.currentPage
		},
        $route: {
            handler: function (route) {
                let {
                    search = '',
                    id = '',
                    brand = '',
                    sort = '',
					pager = ''
					
                } = route.query;
                this.search = search;
                this.id = id;
                this.brand_id = brand;
                this.sort = sort;
				this.pager = pager
				
            },
            immediate: true
        }
    },
    methods: {
        ...mapMutations([
            "setUserGoods",
            "handleUserGoodsCollection"
        ]),
        ...mapActions([
            "getUserGoods",
            "getUserGoodsBrand",
            "requestCollection"
        ]),
        handleData(search, id, brand, sort, page = 1) {
            this.getUserGoodsBrand({
                id, 
                brand
            })
            this.getUserGoods({
                id,
                brand,
                sort,
                search,
                page,
				successively:this.successively
	
            })
        },
        handleFun (search, id, brand, sort, page) {
            this.$router.push({
                name: 'goods',
                query: {
                    search,
                    id,
                    brand,
                    sort,
                    page,
					successively:this.successively,
					pager:this.pager + 1
                }
            }).catch(err => {err})
        },
        handleMove(val){
            this.enter_index = val;
        },
		handleSizeChange(e){
			// console.log("查看1",e)
		},
		handleCurrentChange(e){
			console.log("查看2",e)
		},
        handleCollection(goods){ // 收藏操作
            let { goods_id, goods_sn, goods_name } = goods;
            this.requestCollection({
                goods_id,
                goods_sn,
                goods_name
            }).then((res) => {
                if(res == 1){
                    this.handleUserGoodsCollection({
                        id: goods_id,
                        status: 1
                    })
                    this.$message({
                        showClose: true,
                        message: this.$t("message.plist.collection3"),
                        type: 'success'
                    })
                }else if(res == 3){
                    this.handleUserGoodsCollection({
                        id: goods_id,
                        status: 0
                    })
                    this.$message({
                        showClose: true,
                        message: this.$t("message.plist.collection4"),
                        type: 'success'
                    })
                }
            })
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // let allow = vm.power.includes(0) || vm.character_id==2 || vm.character_id==3;
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(16);
				if(!allow){
				    vm.$router.back();
				    return false;
				}else{
				    let {
				        search = '',
				        id = '',
				        brand = '',
				        sort = '',
				        page
				    } = to.query;
				    vm.handleData(search, id, brand, sort, page);
				}
			}, 500)
        })
    },
    beforeRouteUpdate (to, from, next) {
        let {
            search = '',
            id = '',
            brand = '',
            sort = '',
            page
        } = to.query;
        this.handleData(search, id, brand, sort, page)
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.setUserGoods(false);
        next();
    }
}
</script>

<style scoped>
/* 筛选条件 */
.goods-filter {
    margin-bottom: 30px;
    padding: 20px 10px;
    background: #fff;
}
/* 商品部分 */
.goods-content{
    padding: 20px 0;
    background: #fff;
}

/* 商品盒子 */
.center-goods-box{
    position: relative;
}
.hover-box>.center-goods-collection{
    z-index: 3;
    opacity: 0.8;
}
.hover-box>.center-goods-collection:hover{
    background: #ff6700;
}
/* 收藏盒子 */
.center-goods-collection{
    position: absolute;
    top: 15px;
    right: 15px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #909399;
    opacity: 0;
    transition: all 0.2s linear;
    z-index: -1;
}
.center-goods-collection>a{
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%,-50%);
    display: block;
    color: #fff;
}
.center-goods-collection i{
    line-height: normal;
    font-size: 30px;
}
/* 已收藏样式 */
.is-collection{
    background-color: transparent !important;
    opacity: 1;
    z-index: 100;
}
.is-collection>a{
    color: #ff6700;
}

/* 暂无商品 */
.content-nothing{
    padding: 200px 0;
    text-align: center;
    font-size: 20px;
    color: #909399;
}

/* 分页器 */
.content-pagination{
    margin: 20px 0;
    text-align: right;
}
</style>
